import { useState, useCallback } from "react";
import type { PriorityFilter } from "@/presentation/components/packing/types";

export interface UsePackingFiltersReturn {
  showUncheckedOnly: boolean;
  priorityFilter: PriorityFilter;
  onToggleShowUncheckedOnly: () => void;
  onPriorityFilterChange: (filter: PriorityFilter) => void;
}

/**
 * Hook for managing packing list filter state.
 * Handles unchecked-only toggle and priority filtering.
 */
export function usePackingFilters(): UsePackingFiltersReturn {
  const [showUncheckedOnly, setShowUncheckedOnly] = useState(false);
  const [priorityFilter, setPriorityFilter] = useState<PriorityFilter>("all");

  const onToggleShowUncheckedOnly = useCallback(() => {
    setShowUncheckedOnly((prev) => !prev);
  }, []);

  const onPriorityFilterChange = useCallback((filter: PriorityFilter) => {
    setPriorityFilter(filter);
  }, []);

  return {
    showUncheckedOnly,
    priorityFilter,
    onToggleShowUncheckedOnly,
    onPriorityFilterChange,
  };
}
